import React from "react";
import { PageShell, EditableSection } from "./PageShell";

const SECTIONS = [
  { heading: "Strictly necessary", body: "These are set by Shopify and required for your cart and checkout to function. They cannot be disabled without breaking the site. Retention: session-only or up to 30 days." },
  { heading: "Preferences", body: "These remember your currency, country, and language selection. Retention: 12 months. You can clear them anytime via your browser settings." },
  { heading: "Analytics (privacy-first)", body: "We use Plausible — a cookie-less, GDPR-compliant analytics tool. No personal data is collected. If you’d rather opt out entirely, block analytics domains in your browser or use uBlock Origin." },
  { heading: "Marketing (opt-in only)", body: "If you subscribe to our newsletter, Klaviyo sets a cookie so we can attribute a purchase to a specific campaign. No tracking begins without your explicit consent. Retention: 24 months." },
  { heading: "Managing your consent", body: "To adjust your cookie preferences at any time, click the ‘Cookie settings’ link in the footer or clear your browser storage. In the EU, EEA, and UK, a consent banner is shown before any non-essential cookie is set." },
];

export default function CookiesPage() {
  return (
    <PageShell
      slug="cookies"
      testid="cookies"
      eyebrow="Legal"
      title="Cookie Policy"
      intro="Some small text files help our site work. Here’s exactly what we use and why."
    >
      <EditableSection slug="cookies" sectionKey="clauses" fallback={SECTIONS} />
    </PageShell>
  );
}
